const ONBOARD = {
  ONBOARD_BUSINESS: "ONBOARD_BUSINESS",
  ONBOARD_EMPLOYEE: "ONBOARD_EMPLOYEE",
  ONBOARD_INVITE: "ONBOARD_INVITE",
  LOADING_ONBOARD: "LOADING_ONBOARD",
};
export default ONBOARD;
